/* PUREGLASS CRO kit: finder, delivery promise, shipping estimator, resin calculator modal, cart upsell helpers */
(() => {
  if (window.__pgCro) return;
  window.__pgCro = true;

  /* ---------- Finder ---------- */
  const finderSections = () => document.querySelectorAll('[data-pg-finder]');

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.pgf__chip');
    if (chip && !chip.disabled) {
      e.preventDefault();
      const param = chip.dataset.param;
      const values = (chip.dataset.values || '').split('§').filter(Boolean);
      const wasOn = chip.classList.contains('is-on');
      const url = new URL(location.href);
      url.searchParams.delete(param);
      if (!wasOn) values.forEach((v) => url.searchParams.append(param, v));
      url.searchParams.delete('page');
      chip.closest('[data-pg-finder]')?.classList.add('is-loading');
      location.assign(url.toString());
      return;
    }
    const reset = e.target.closest('[data-pgf-reset]');
    if (reset) {
      const sec = reset.closest('[data-pg-finder]');
      const url = new URL(location.href);
      sec.querySelectorAll('.pgf__chip').forEach((c) => url.searchParams.delete(c.dataset.param));
      url.searchParams.delete('page');
      location.assign(url.toString());
      return;
    }
    const edit = e.target.closest('[data-pgf-edit]');
    if (edit) {
      const sec = edit.closest('[data-pg-finder]');
      const open = sec.classList.toggle('is-open');
      edit.setAttribute('aria-expanded', String(open));
      edit.textContent = open ? 'Done' : 'Edit';
    }
  });

  // Keep finder in sync when the theme filters results without a page load.
  let lastSearch = location.search;
  let t;
  const refreshFinders = () => {
    if (location.search === lastSearch) return;
    lastSearch = location.search;
    clearTimeout(t);
    t = setTimeout(() => {
      finderSections().forEach(async (sec) => {
        const id = sec.dataset.section;
        const wrap = document.getElementById('shopify-section-' + id);
        if (!wrap) return;
        const u = new URL(location.href);
        u.searchParams.set('section_id', id);
        try {
          const html = await (await fetch(u.toString())).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-pg-finder]');
          if (fresh) wrap.querySelector('[data-pg-finder]')?.replaceWith(fresh);
        } catch (err) {}
      });
    }, 150);
  };
  ['pushState', 'replaceState'].forEach((m) => {
    const orig = history[m];
    history[m] = function () {
      const r = orig.apply(this, arguments);
      setTimeout(refreshFinders, 0);
      return r;
    };
  });
  window.addEventListener('popstate', refreshFinders);

  /* ---------- Shared helpers ---------- */
  const money = (cents) => '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  const shipMap = () => {
    if (window.__pgShipMap) return window.__pgShipMap;
    const el = document.getElementById('pg-ship-map');
    let m = { c: [], b: [] };
    try { if (el) m = JSON.parse(el.textContent); } catch (e) {}
    window.__pgShipMap = { c: new Set(m.c.map(String)), b: new Set(m.b.map(String)) };
    return window.__pgShipMap;
  };
  const profileOf = (vid) => {
    const m = shipMap();
    vid = String(vid);
    return m.b.has(vid) ? 'brand' : m.c.has(vid) ? 'carrier' : 'general';
  };
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const announceCart = (cart, variantId) => {
    try {
      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'pg-cro', data: { source: 'pg-cro', itemCount: cart.item_count, variantId: String(variantId || '') } };
      document.dispatchEvent(ev);
    } catch (e) {}
  };
  window.PGCro = Object.assign(window.PGCro || {}, { money, profileOf, getCart, announceCart });

  /* ---------- Delivery dates (Pacific time) ---------- */
  const TZ = 'America/Los_Angeles';
  const laNow = () => {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const g = (t) => parseInt(parts.find((p) => p.type === t).value, 10);
    return { day: new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), mins: g('hour') * 60 + g('minute') };
  };
  const ymd = (d) => d.toISOString().slice(0, 10);
  const isoDow = (d) => ((d.getUTCDay() + 6) % 7) + 1;
  const addDays = (d, n) => new Date(d.getTime() + n * 86400000);
  const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
  const deliveryWindow = (cfg) => {
    const days = (cfg.days || ['1', '2', '3', '4', '5']).map((x) => parseInt(x, 10));
    const hol = new Set(cfg.holidays || []);
    const shipOk = (d) => days.includes(isoDow(d)) && !hol.has(ymd(d));
    const bizOk = (d) => isoDow(d) <= 5 && !hol.has(ymd(d));
    const now = laNow();
    const cutoff = (cfg.cutoff || 12) * 60;
    let ship = now.day;
    const today = shipOk(ship) && now.mins < cutoff;
    if (!today) { ship = addDays(ship, 1); while (!shipOk(ship)) ship = addDays(ship, 1); }
    const addBiz = (d, n) => { let x = d; let c = 0; while (c < n) { x = addDays(x, 1); if (bizOk(x)) c++; } return x; };
    const left = cutoff - now.mins;
    return { ship, today, a: addBiz(ship, cfg.tmin || 2), b: addBiz(ship, cfg.tmax || 5), left, isTomorrow: ymd(ship) === ymd(addDays(now.day, 1)) };
  };
  window.PGCro.deliveryWindow = deliveryWindow;
  window.PGCro.fmtDate = fmt;

  /* ---------- ZIP to state (US) ---------- */
  const ZIP3 = [[5,5,'NY'],[6,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,54,'VT'],[55,55,'MA'],[56,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[569,569,'DC'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  const zipState = (zip) => { const n = parseInt(String(zip).slice(0, 3), 10); const r = ZIP3.find(([a, b]) => n >= a && n <= b); return r ? r[2] : ''; };
  const shippingRates = async (zip) => {
    const q = new URLSearchParams({ 'shipping_address[zip]': zip, 'shipping_address[country]': 'United States', 'shipping_address[province]': zipState(zip) }).toString();
    const prep = await fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' });
    if (!prep.ok) { let msg = 'We could not get rates for that ZIP.'; try { const j = await prep.json(); msg = Object.values(j).flat().join(' ') || msg; } catch (e) {} throw new Error(msg); }
    for (let i = 0; i < 12; i++) {
      const r = await fetch('/cart/async_shipping_rates.json?' + q);
      if (r.status === 200) { const j = await r.json(); if (j && j.shipping_rates) return j.shipping_rates; }
      await new Promise((res) => setTimeout(res, 700));
    }
    throw new Error('Rates are taking longer than usual. Try again in a moment.');
  };
  window.PGCro.shippingRates = shippingRates;

  /* ---------- PDP delivery promise ---------- */
  const initShip = (box) => {
    if (box.__pg) return; box.__pg = true;
    let cfg = {};
    try { cfg = JSON.parse(box.querySelector('[data-pgs-cfg]').textContent); } catch (e) {}
    const $ = (s) => box.querySelector(s);
    let vid = box.dataset.variant;
    let cart = null;
    const form = () => document.querySelector('form[action*="/cart/add"] [name="id"]');
    const qty = () => parseInt(document.querySelector('form[action*="/cart/add"] [name="quantity"]')?.value || '1', 10) || 1;
    const price = () => (cfg.variants && cfg.variants[vid]) || parseInt(box.dataset.price, 10) || 0;

    const renderDate = () => {
      const prof = profileOf(vid);
      const row = $('[data-pgs-date-row]');
      if (prof === 'brand') { row.hidden = true; return; }
      row.hidden = false;
      const w = deliveryWindow(cfg);
      $('[data-pgs-date]').textContent = 'Arrives ' + fmt(w.a) + ' – ' + fmt(w.b);
      if (w.today) {
        const h = Math.floor(w.left / 60), m = w.left % 60;
        $('[data-pgs-cut]').textContent = 'Order in the next ' + (h ? h + 'h ' : '') + m + 'm to ship today from Costa Mesa';
      } else {
        $('[data-pgs-cut]').textContent = 'Ships ' + (w.isTomorrow ? 'tomorrow' : fmt(w.ship)) + ' from Costa Mesa';
      }
    };
    const renderProfile = () => {
      const prof = profileOf(vid);
      const free = $('[data-pgs-free]'), ok = $('[data-pgs-freeok]');
      $('[data-pgs-carrier]').hidden = prof !== 'carrier';
      $('[data-pgs-brand]').hidden = prof !== 'brand';
      const pk = $('[data-pgs-pickup]'); if (pk) pk.hidden = prof === 'brand';
      free.hidden = true; ok.hidden = true;
      if (prof === 'general' && cfg.threshold) {
        let inCart = 0;
        if (cart) cart.items.forEach((it) => { if (profileOf(it.variant_id) === 'general') inCart += it.final_line_price; });
        const already = cart && cart.items.some((it) => String(it.variant_id) === String(vid));
        const total = inCart + (already ? 0 : price() * qty());
        const rem = cfg.threshold - total;
        if (rem <= 0) ok.hidden = false;
        else {
          free.hidden = false;
          $('[data-pgs-free-r]').textContent = money(rem) + ' away from free';
          $('[data-pgs-bar]').style.width = Math.min(100, Math.round((total / cfg.threshold) * 100)) + '%';
        }
      }
      const btn = $('[data-pgs-zip-btn]');
      if (btn) btn.textContent = cart && cart.items.some((it) => String(it.variant_id) === String(vid)) ? 'Estimate' : 'Add & estimate';
    };
    const refresh = () => { renderDate(); renderProfile(); };
    const loadCart = () => getCart().then((c) => { cart = c; renderProfile(); }).catch(() => {});

    refresh(); loadCart();
    setInterval(renderDate, 60000);
    document.addEventListener('variant:update', (e) => { const id = e.detail?.resource?.id; if (id) { vid = String(id); refresh(); } });
    document.addEventListener('cart:update', () => setTimeout(loadCart, 300));
    document.addEventListener('change', (e) => { if (e.target.matches('[name="quantity"]')) renderProfile(); });
    setInterval(() => { const f = form(); if (f && f.value && f.value !== vid) { vid = f.value; refresh(); } }, 800);

    const zipForm = $('[data-pgs-zip]');
    if (zipForm) zipForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = zipForm.querySelector('input');
      const out = $('[data-pgs-rates]');
      const zip = (input.value || '').trim();
      if (!/^\d{5}$/.test(zip)) { out.innerHTML = '<p class="pgs__err">Enter a 5-digit US ZIP code.</p>'; input.focus(); return; }
      const btn = zipForm.querySelector('button'); btn.disabled = true; out.innerHTML = '<p class="pgs__sub">Getting the checkout rate…</p>';
      try {
        if (!cart || !cart.items.some((it) => String(it.variant_id) === String(vid))) {
          const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty() }] }) });
          if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || 'Could not add this item.'); }
          cart = await getCart(); announceCart(cart, vid); renderProfile();
        }
        const rates = await shippingRates(zip);
        const w = deliveryWindow(cfg);
        out.innerHTML = rates.length ? rates.map((r, i) => '<div class="pgs__rate' + (i === 0 ? ' is-best' : '') + '"><div><b>' + r.name + '</b><small>' + (/ground/i.test(r.name) ? 'Arrives ' + fmt(w.a) + ' – ' + fmt(w.b) : 'Rate for your whole cart') + '</small></div><span>' + (parseFloat(r.price) === 0 ? 'Free' : '$' + parseFloat(r.price).toFixed(2)) + '</span></div>').join('') + '<p class="pgs__fine">Rates are for everything in your cart, to ' + zip + '. Same as checkout.</p>' : '<p class="pgs__sub">No shipping rates for that ZIP. Local pickup is still available.</p>';
      } catch (err) {
        out.innerHTML = '<p class="pgs__err">' + (err.message || 'Something went wrong.') + '</p>';
      } finally { btn.disabled = false; }
    });
  };

  /* ---------- Resin calculator lightbox ---------- */
  const RESIN = { 5: { bot: 14, deck: 20, hot: 12 }, 5.5: { bot: 16, deck: 22, hot: 13 }, 6: { bot: 18, deck: 26, hot: 15 }, 6.5: { bot: 20, deck: 28, hot: 16 }, 7: { bot: 22, deck: 32, hot: 18 }, 7.5: { bot: 26, deck: 36, hot: 20 }, 8: { bot: 30, deck: 42, hot: 24 }, 9: { bot: 38, deck: 52, hot: 30 } };
  const GLASS = { 5: { yd4: 1.5, yd6: 1.0 }, 5.5: { yd4: 2.0, yd6: 1.5 }, 6: { yd4: 2.5, yd6: 2.0 }, 6.5: { yd4: 2.5, yd6: 2.5 }, 7: { yd4: 3.0, yd6: 2.5 }, 7.5: { yd4: 3.0, yd6: 3.0 }, 8: { yd4: 3.5, yd6: 3.0 }, 9: { yd4: 4.0, yd6: 4.0 } };
  const KIT_SIZES = [{ oz: 48, k: ['1.5 quart', '1.5qt', '1.5 qt'], s: '1.5 Qt' }, { oz: 96, k: ['3 quart', '3qt', '3 qt'], s: '3 Qt' }, { oz: 192, k: ['1.5 gallon', '1.5gal', '1.5 gal'], s: '1.5 Gal' }, { oz: 384, k: ['3 gallon', '3gal', '3 gal'], s: '3 Gal' }];
  const GLASS_SIZES = [{ yards: 1, k: ['1 yard'] }, { yards: 7, k: ['7 yard'] }, { yards: 10, k: ['10 yard'] }, { yards: 20, k: ['20 yard'] }];
  const LEN_LABEL = { 5: 'Under 5\'6"', 5.5: '5\'6"–6\'0"', 6: '6\'0"–6\'6"', 6.5: '6\'6"–7\'0"', 7: '7\'0"–7\'6"', 7.5: '7\'6"–8\'0"', 8: '8\'0"–9\'0"', 9: '9\'0"+' };

  const initCalc = (dlg) => {
    if (dlg.__pg) return; dlg.__pg = true;
    let data = { variants: [], glass: [] };
    try { data = JSON.parse(dlg.querySelector('[data-pgk-data]').textContent); } catch (e) {}
    const $ = (s) => dlg.querySelector(s);
    const state = { len: 6, sched: 'standard' };
    let pick = null; let cloth = [];
    const curVariant = () => { const id = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value; return data.variants.find((v) => String(v.id) === String(id)) || data.variants[0]; };
    const sizeIdx = (v) => { const t = (v.title || '').toLowerCase(); return KIT_SIZES.findIndex((s) => s.k.some((k) => t.includes(k))); };
    const resinLine = () => { const v = curVariant(); const other = v ? v.options.filter((o, i) => sizeIdx({ title: o }) < 0) : []; $('[data-pgk-resin]').textContent = 'Resin: ' + data.product + (other.length ? ' · ' + other.join(' · ') : '') + ', from this product'; };

    dlg.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-pgk-group] button');
      if (opt) { const g = opt.closest('[data-pgk-group]'); g.querySelectorAll('button').forEach((b) => b.classList.toggle('is-on', b === opt)); state[g.dataset.pgkGroup] = g.dataset.pgkGroup === 'len' ? parseFloat(opt.dataset.v) : opt.dataset.v; return; }
      if (e.target.closest('[data-pgk-close]') || e.target === dlg) { dlg.close(); return; }
      if (e.target.closest('[data-pgk-back]')) { $('[data-pgk-step="2"]').hidden = true; $('[data-pgk-step="1"]').hidden = false; return; }
      if (e.target.closest('[data-pgk-calc]')) { calc(); return; }
      if (e.target.closest('[data-pgk-select]')) { select(); }
    });

    const calc = () => {
      const rd = RESIN[state.len], buf = 1.15;
      const extra = state.sched === 'light' ? 0 : state.sched === 'standard' ? 6 : 14;
      const hot = $('[data-pgk-hot]').checked;
      const bot = Math.round(rd.bot * buf), deck = Math.round((rd.deck + extra) * buf), hc = hot ? Math.round(rd.hot * buf) : 0;
      const total = bot + deck + hc;
      $('[data-pgk-summary]').textContent = LEN_LABEL[state.len] + ' · ' + state.sched + (hot ? ' · hot coat' : '');
      $('[data-pgk-total]').textContent = 'You need ~' + total + ' oz of resin.';
      $('[data-pgk-stats]').innerHTML = [['Bottom lam', bot], ['Deck lam', deck]].concat(hot ? [['Hot coat', hc]] : []).map(([l, v]) => '<div><small>' + l + '</small><b>' + v + ' oz</b></div>').join('');
      const cur = curVariant();
      const others = cur ? cur.options.filter((o) => sizeIdx({ title: o }) < 0) : [];
      const sameOthers = (v) => others.every((o) => v.options.includes(o));
      let idx = KIT_SIZES.findIndex((s) => total <= s.oz); if (idx < 0) idx = KIT_SIZES.length - 1;
      let qty = Math.ceil(total / KIT_SIZES[idx].oz);
      pick = null;
      for (let i = idx; i < KIT_SIZES.length && !pick; i++) {
        const v = data.variants.find((x) => sizeIdx(x) === i && sameOthers(x) && x.available) || data.variants.find((x) => sizeIdx(x) === i && x.available);
        if (v) { pick = { v, i, qty: i === idx ? qty : 1 }; }
      }
      if (!pick && cur) pick = { v: cur, i: sizeIdx(cur), qty: 1 };
      const sz = pick && pick.i >= 0 ? KIT_SIZES[pick.i] : null;
      $('[data-pgk-pick]').textContent = (pick.qty > 1 ? pick.qty + ' × ' : '') + (sz ? sz.s + ' kit' : pick.v.title);
      $('[data-pgk-pick-price]').textContent = money(pick.v.price * pick.qty);
      const smaller = pick.i > 0 ? KIT_SIZES[pick.i - 1] : null;
      $('[data-pgk-pick-why]').textContent = (total / 32).toFixed(2) + ' qt needed.' + (smaller ? ' The ' + smaller.s + ' kit would leave you short mid-lam.' : '');
      $('[data-pgk-select]').textContent = 'Select ' + (pick.qty > 1 ? pick.qty + ' × ' : '') + (sz ? sz.s + ' kit' : 'this kit') + ' · ' + money(pick.v.price * pick.qty);
      // cloth (same schedule logic as the full calculator)
      const gd = GLASS[state.len]; let y4 = 0, y6 = 0;
      if (state.sched === 'light') y4 = Math.ceil(gd.yd4 * 2 * 1.1); else if (state.sched === 'standard') { y6 = Math.ceil(gd.yd6 * 2 * 1.1); y4 = Math.ceil(gd.yd4 * 1.1); } else y6 = Math.ceil(gd.yd6 * 3 * 1.1);
      const findGlass = (yards, w) => { if (!yards) return null; let t = GLASS_SIZES[GLASS_SIZES.length - 1]; for (const s of GLASS_SIZES) { if (yards < s.yards) { t = s; break; } } const m = data.glass.find((g) => { const x = g.t.toLowerCase(); return g.available && x.includes(w + 'oz') && x.includes('"e"') !== false && t.k.some((k) => x.includes(k)); }); return m ? { ...m, need: yards, w } : null; };
      cloth = [findGlass(y6, 6), findGlass(y4, 4)].filter(Boolean);
      const cw = $('[data-pgk-cloth-wrap]');
      if (cloth.length) { cw.hidden = false; $('[data-pgk-cloth]').checked = false; $('[data-pgk-cloth-label]').textContent = 'Also add the cloth: ' + cloth.map((c) => c.w + 'oz (' + c.need + ' yd needed)').join(' + ') + ' · ' + money(cloth.reduce((a, c) => a + c.price, 0)); } else cw.hidden = true;
      $('[data-pgk-step="1"]').hidden = true; $('[data-pgk-step="2"]').hidden = false;
    };

    const select = async () => {
      if (!pick) return;
      // select the kit in the product page picker
      const opts = pick.v.options;
      opts.forEach((val) => {
        const input = [...document.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]')].find((i) => i.value === val);
        if (input && !input.checked) { input.click(); }
        const sel = [...document.querySelectorAll('variant-picker select, .variant-picker select')].find((s) => [...s.options].some((o) => o.value === val || o.textContent.trim() === val));
        if (sel) { const o = [...sel.options].find((o) => o.value === val || o.textContent.trim() === val); if (o && !o.selected) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); } }
      });
      setTimeout(() => { const q = document.querySelector('form[action*="/cart/add"] [name="quantity"]'); if (q && pick.qty > 1) { q.value = pick.qty; q.dispatchEvent(new Event('change', { bubbles: true })); } }, 400);
      if ($('[data-pgk-cloth]').checked && cloth.length) {
        try {
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: cloth.map((c) => ({ id: c.id, quantity: 1 })) }) });
          announceCart(await getCart(), cloth[0].id);
        } catch (e) {}
      }
      dlg.close();
      document.querySelector('form[action*="/cart/add"] [type="submit"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    document.addEventListener('click', (e) => { if (e.target.closest('[data-pgk-open]')) { resinLine(); $('[data-pgk-step="2"]').hidden = true; $('[data-pgk-step="1"]').hidden = false; dlg.showModal(); } });
  };

  /* ---------- Complete the set (PDP + cart drawer) ---------- */
  const recCache = {};
  const fetchRecs = async (productId, limit) => {
    const key = productId + ':' + limit;
    if (recCache[key]) return recCache[key];
    const get = async (intent) => {
      const html = await (await fetch('/recommendations/products?section_id=pg-complete-set&product_id=' + productId + '&limit=' + limit + '&intent=' + intent)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return [...doc.querySelectorAll('[data-pgx-items] .pgx__item')];
    };
    let items = [];
    try { items = await get('complementary'); } catch (e) {}
    // Complementary only (set in Search & Discovery). No fallback: an empty module beats an irrelevant one.
    recCache[key] = items.map((i) => i.outerHTML);
    return recCache[key];
  };
  const initComplete = async (sec) => {
    if (sec.__pg) return; sec.__pg = true;
    const pid = new URL(sec.dataset.url, location.origin).searchParams.get('product_id');
    const items = (await fetchRecs(pid, 6)).filter((h) => !h.includes('data-pid="' + pid + '"')).slice(0, 3);
    if (!items.length) return;
    const grid = document.createElement('div'); grid.className = 'pgx__grid'; grid.innerHTML = items.join('');
    sec.querySelector('[data-pgx-slot]').replaceWith(grid);
    sec.hidden = false;
  };
  const initCartRecs = async (box) => {
    // The theme morphs the drawer on every cart change: our attribute disappears, so we re-render (from cache).
    const pid = box.dataset.product; const inCart = box.dataset.inCart || '';
    if (!pid || box.__loading || box.dataset.pgDone === pid + inCart) return;
    box.__loading = true;
    const items = (await fetchRecs(pid, 8).catch(() => [])).filter((h) => { const m = h.match(/data-pid="(\d+)"/); return m && !inCart.includes(',' + m[1] + ','); }).slice(0, 3);
    box.__loading = false;
    if (!items.length || !box.isConnected) return;
    const slot = box.querySelector('[data-pgcart-slot]');
    const grid = document.createElement('div'); grid.className = 'pgx__grid pgx__grid--cart'; grid.innerHTML = items.join('');
    slot.replaceChildren(grid);
    box.querySelector('[data-pgcart-recs]').hidden = false;
    box.dataset.pgDone = pid + inCart;
  };
  new MutationObserver(() => { document.querySelectorAll('[data-pgcart]').forEach(initCartRecs); document.querySelectorAll('[data-pg-ship]').forEach(initShip); }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-pgx-add]');
    if (!b) return;
    b.disabled = true; const t = b.textContent; b.textContent = 'Adding…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.pgxAdd), quantity: 1 }] }) });
      if (!r.ok) throw 0;
      b.textContent = 'Added ✓'; b.classList.add('is-done');
      announceCart(await getCart(), b.dataset.pgxAdd);
    } catch (err) { b.textContent = t; b.disabled = false; }
  });

  /* ---------- Hide filter groups with a single option (nothing to choose) ---------- */
  const tidyFacets = () => {
    document.querySelectorAll('.facets details, .facets accordion-custom').forEach((g) => {
      const inputs = g.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      if (!inputs.length) return;
      const values = new Set([...inputs].map((i) => i.name + '=' + i.value));
      const anyOn = [...inputs].some((i) => i.checked);
      const hide = values.size < 2 && !anyOn;
      const host = g.closest('.facets__item, li, .facets__filters-wrapper > *') || g;
      if (host.dataset.pgHidden !== String(hide)) { host.dataset.pgHidden = String(hide); host.style.display = hide ? 'none' : ''; }
    });
  };
  new MutationObserver(() => { clearTimeout(window.__pgTidy); window.__pgTidy = setTimeout(tidyFacets, 50); }).observe(document.documentElement, { childList: true, subtree: true });

  const boot = () => {
    tidyFacets();
    document.querySelectorAll('[data-pg-ship]').forEach(initShip);
    document.querySelectorAll('[data-pgk]').forEach(initCalc);
    document.querySelectorAll('[data-pgx]').forEach(initComplete);
    document.querySelectorAll('[data-pgcart]').forEach(initCartRecs);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.PGCro.boot = boot;
})();
